module.exports = __webpack_public_path__ + "img/xingxushi_act.0e4d3c1e.svg";